import React from 'react';
import { styled, css } from 'styled-components';

// Components
import { Link as ParentLink, LinkProps as ParentLinkProps } from '@ui/next-link';

// Types
export interface StyledLinkProps extends ParentLinkProps {}
export interface LinkProps extends StyledLinkProps {}

// Styled css
export const linkCss = css<StyledLinkProps>`
  display: inline-flex;
  cursor: pointer;
  text-decoration: none;
  &[data-disabled='true'] {
    cursor: default;
  }
`;
export const Link: React.FC<LinkProps> = styled(ParentLink)<LinkProps>``;